import { jsx as _jsx } from "react/jsx-runtime";
import { getTimezone, useSession } from '../../../../../../../infra/session';
import { isRecurringCampaign } from '../../../../../campaign-utils';
import { DateTimeView } from './date-time';
import { formatCampaignDateTime } from './utils';
import { shouldShowDateTime } from '../../utils';
export var DateTimeContainer = function (_a) {
    var _b, _c;
    var campaign = _a.campaign;
    var session = useSession().data;
    var timezone = getTimezone(session);
    if (!shouldShowDateTime(campaign)) {
        return null;
    }
    return (_jsx(DateTimeView, { showRecurringInterval: isRecurringCampaign(campaign), recurringInterval: (_b = campaign.recurrenceRule) === null || _b === void 0 ? void 0 : _b.interval, recurringFrequency: (_c = campaign.recurrenceRule) === null || _c === void 0 ? void 0 : _c.frequency, formattedDateTime: formatCampaignDateTime(campaign, timezone), campaignId: campaign.id }));
};
